<footer class="bg-light text-center py-2">
  <div class="container">
    <p class="mb-0">Copyright &copy; {{ currentYear }} TIECHE Inc. All Rights Reserved.</p>
  </div>
</footer>